import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { VisitsController } from "../scripts/visits.controller";
import { VisitsDialog } from "../scripts/visits.dialog";
import { VisitEvent } from "../scripts/visits.entities";
import { VisitLookup } from "../scripts/visits.lookup";
import { VisitSummarySeries } from "./visits-summary.entities";

var Highcharts = require('highcharts/highcharts');


export class VisitsSummaryView {

    visitSummaryChart: any;
    siteSummaryChart: any;
    visitCompletionChart: any;
    siteCompletionChart: any;

    selectedGrouping: string; //visit, site
    selectedData: string; //summary, completion

    constructor() {
        this.selectedGrouping = "visit";
        this.selectedData = "status";
    }

    UpdateData(visitSeries: VisitSummarySeries[], siteSeries: VisitSummarySeries[]): void {

        //console.log(visitSeries);
        //console.log(siteSeries);

        this.updateChart('visit-byvisit-summary-status-chart', visitSeries, [1, 3, 4, 5, 6, 7], "Visits");
        this.updateChart('visit-bysite-summary-status-chart', siteSeries, [1, 3, 4, 5, 6, 7], "Sites");
        this.updateChart('visit-byvisit-summary-completion-chart', visitSeries, [20, 21, 22, 23, 24], "Visits");
        this.updateChart('visit-bysite-summary-completion-chart', siteSeries, [20, 21, 22, 23, 24], "Sites");
    }

    private updateChart(chartId: string, data: VisitSummarySeries[], visitStatusIds: number[], axisLabel: string): void {

        let series: any[] = [];
        let categories: string[] = [];
        let visits: VisitEvent[] = [];

        visitStatusIds.forEach((statusId: number) => {

            let seriesData: any[] = new Array<any>(data.length).fill(0);
            //let seriesData: number[] = new Array<number>(data.length).fill(0);
            //let visitsData: any[] = [];
            for (let i = 0; i < data.length; ++i) {

                if (!categories.includes(data[i].name)) { categories.push(data[i].name); }
                //if (data[i].data.has(statusId)) {
                //    seriesData[i] = data[i].data.get(statusId);
                //    visits.push(...data[i].visits);
                //}
                if (data[i].visits.has(statusId)) {
                    seriesData[i] = { y: data[i].visits.get(statusId).length, visits: data[i].visits.get(statusId) };
                    //seriesData[i] = data[i].visits.get(statusId).length;
                    //visitsData[i] = data[i].visits.get(statusId);
                }
            }

            series.push({ name: VisitLookup.GetVisitStatus(statusId), data: seriesData, colorIndex: VisitLookup.GetVisitColorIndex(statusId) });
        });

        this.initializeBarChart(chartId, axisLabel, categories, series);
    }

    private initializeBarChart(chartId: string, axisLabel: string, categories: string[], data: any[]): any {

        //console.log(chartId, axisLabel, categories, data);
        //console.log(categories.length, (40 * categories.length));
        //console.log(data);

        let chart: any = Highcharts.chart(chartId, {
            chart: {
                type: 'bar',
                styledMode: true,
                height: 100 + (45 * categories.length)
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'category',
                categories: categories,
                min: 0,
                max: categories.length - 1,
                title: { text: axisLabel },
                tickInterval: 1,
                tickLength: 0,
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.2, // larger value has more space for data labels (default is 0.05)
                reversedStacks: false,
                title: { text: 'Visit Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');
                    },
                    inside: false, //label issues
                    verticalAlign: 'middle',
                }
            },
            legend: {
            //    enabled: false,
            //    reversed: false,
            //    title: {
            //        text: '<div style="font-size: 10px; color: #666; font-weight: normal; width: 100%; text-align: center">Visits</span>',
            //    },
                align: 'center',
                verticalAlign: 'top',
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    point: {
                        events: {
                            click: function () {
                                VisitsDialog.ShowDialog(this.options.visits);
                            }
                        }
                    },
                },
                bar: {
                    pointWidth: 25,
                    pointPadding: 0.1,
                    //groupPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            if (this.y == 0) return null;
                            else {
                                let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                else return label;
                            }
                        },
                        verticalAlign: 'middle',
                        y: 2
                    },
                },
            },
            series: data
        });

        return chart;
    }


    SetView(newView: string): void {

        if (!newView.startsWith("visit-summary")) { return; }
        else if (newView != "visit-summary") { //new within-summary view
            if (newView.includes("byvisit")) { this.selectedGrouping = "visit"; }
            else if (newView.includes("bysite")) { this.selectedGrouping = "site"; }

            if (newView.includes("bystatus")) { this.selectedData = "status"; }
            else if (newView.includes("bycompletion")) { this.selectedData = "completion"; }            
        }

        if (this.selectedGrouping == "visit" && this.selectedData == "status") { SetActiveTab("visit-summary-tabs", "content-summary-visit-byvisit-status"); }
        else if (this.selectedGrouping == "site" && this.selectedData == "status") { SetActiveTab("visit-summary-tabs", "content-summary-visit-bysite-status"); }
        else if (this.selectedGrouping == "visit" && this.selectedData == "completion") { SetActiveTab("visit-summary-tabs", "content-summary-visit-byvisit-completion"); }
        else if (this.selectedGrouping == "site" && this.selectedData == "completion") { SetActiveTab("visit-summary-tabs", "content-summary-visit-bysite-completion"); }

    }

}

